(function () {
  function initFlavourPicker(root) {
    if (!root || root.dataset.boxFlavoursInit === "true") return;
    root.dataset.boxFlavoursInit = "true";

    var mode = root.dataset.boxMode || "subscribe";
    var selectButtons = root.querySelectorAll("[data-box-select] .box__select-btn");

    selectButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var item = btn.closest(".box__item");
        var selectWrap = item.querySelector("[data-box-select]");
        var qtyWrap = item.querySelector("[data-box-qty]");
        var input = item.querySelector(".box__qty-input");

        selectWrap.hidden = true;
        qtyWrap.hidden = false;
        input.value = "1";
        updateState(root);
      });
    });

    root.querySelectorAll("[data-box-minus]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var item = btn.closest("[data-flavour-item], .box__item");
        changeQty(item, -1, root);
      });
    });

    root.querySelectorAll("[data-box-plus]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var item = btn.closest("[data-flavour-item], .box__item");
        changeQty(item, 1, root);
      });
    });

    updateState(root);
  }

  function getLimit(root) {
    return parseInt(root.dataset.limit, 10) || 4;
  }

  function getMode(root) {
    return root.dataset.boxMode || "subscribe";
  }

  function changeQty(item, delta, root) {
    var limit = getLimit(root);
    var mode = getMode(root);
    var input = item.querySelector(".box__qty-input, .subscribe__qty-input");
    var display = item.querySelector("[data-box-qty-display]");
    var qty = parseInt(input.value, 10) || 0;
    var total = getTotal(root);

    if (delta > 0 && total >= limit) return;

    qty = Math.max(0, qty + delta);
    input.value = String(qty);
    if (display) display.textContent = String(qty);

    if (mode === "product" && qty === 0) {
      var selectWrap = item.querySelector("[data-box-select]");
      var qtyWrap = item.querySelector("[data-box-qty]");
      if (selectWrap) selectWrap.hidden = false;
      if (qtyWrap) qtyWrap.hidden = true;
    }

    if (mode === "subscribe") {
      item.classList.toggle("subscribe__flavour--active", qty > 0);
    }

    updateState(root);
  }

  function getTotal(root) {
    var total = 0;
    root.querySelectorAll(".box__qty-input, .subscribe__qty-input").forEach(function (input) {
      total += parseInt(input.value, 10) || 0;
    });
    return total;
  }

  function updateState(root) {
    var limit = getLimit(root);
    var mode = getMode(root);
    var total = getTotal(root);
    var isComplete = total === limit;

    root.querySelectorAll("[data-box-minus]").forEach(function (btn) {
      var container = btn.closest("[data-flavour-item], .box__item");
      var input = container.querySelector(".box__qty-input, .subscribe__qty-input");
      btn.disabled = (parseInt(input.value, 10) || 0) <= 0;
    });

    root.querySelectorAll("[data-box-plus]").forEach(function (btn) {
      btn.disabled = total >= limit;
    });

    if (mode === "product") {
      root.querySelectorAll("[data-box-select] .box__select-btn").forEach(function (btn) {
        btn.disabled = total >= limit;
      });
    }

    root.dispatchEvent(
      new CustomEvent("box:change", {
        bubbles: true,
        detail: { total: total, limit: limit, isComplete: isComplete },
      })
    );
  }

  function resetFlavours(root) {
    root.querySelectorAll(".box__qty-input, .subscribe__qty-input").forEach(function (input) {
      input.value = "0";
    });
    root.querySelectorAll("[data-box-qty-display]").forEach(function (el) {
      el.textContent = "0";
    });
    root.querySelectorAll("[data-flavour-item]").forEach(function (item) {
      item.classList.remove("subscribe__flavour--active");
    });
    root.querySelectorAll(".box__item").forEach(function (item) {
      var selectWrap = item.querySelector("[data-box-select]");
      var qtyWrap = item.querySelector("[data-box-qty]");
      if (selectWrap) selectWrap.hidden = false;
      if (qtyWrap) qtyWrap.hidden = true;
    });
    updateState(root);
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-box-flavours]").forEach(initFlavourPicker);
  });

  window.HappyJoBoxFlavours = {
    init: initFlavourPicker,
    reset: resetFlavours,
    getTotal: getTotal,
  };
})();
